import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule} from '@angular/forms';
import {MatMenuModule} from '@angular/material/menu';
import {MatDialogModule} from '@angular/material/dialog';
import {MatRippleModule} from '@angular/material/core';
import {NgxMatDatetimePickerModule} from '@angular-material-components/datetime-picker';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatIconModule} from '@angular/material/icon';
import {DoingComponent} from './doing.component';
import { DoingFormComponent } from './doing-form/doing-form.component';
import {RouterModule} from '@angular/router';
import {NoteModule} from '../note/note.module';
import {PipesModule} from '../../pipes/pipes.module';
import {MatSnackBarModule} from "@angular/material/snack-bar";



@NgModule({
    declarations: [DoingComponent, DoingFormComponent],
  exports: [
    DoingComponent,
    DoingFormComponent

  ],
  imports: [
    CommonModule,
    FormsModule,
    MatMenuModule,
    MatDialogModule,
    MatRippleModule,
    MatDatepickerModule,
    MatIconModule,
    NgxMatDatetimePickerModule,
    NoteModule,
    RouterModule,
    PipesModule
  ]
})
export class DoingModule { }
